import { createFileRoute, notFound } from "@tanstack/react-router";
import GuidePage from "@/pages/GuidePage";
import { legacyRedirect } from "@/lib/legacy-redirect";
import { guideHead, isGuideSlug } from "@/lib/route-seo";
import NotFound from "@/pages/NotFound";

// Consolidate overlapping /guide/ pages → canonical service pages (anti-cannibalization)
const CONSOLIDATED_GUIDES: Record<string, string> = {
  "emergency-electrician-louisville-ky": "/electrical-services/emergency-electrical-service",
  "24-hour-emergency-electrician-louisville-ky": "/electrical-services/emergency-electrical-service",
  "hvac-contractor-louisville-ky": "/hvac-services",
  "heating-cooling-louisville-ky": "/hvac-services",
  "commercial-electrical-contractor-louisville-2026": "/electrical-services/commercial-electrical-contractor",
};

export const Route = createFileRoute("/guide/$slug")({
  beforeLoad: ({ params }) => {
    const target = CONSOLIDATED_GUIDES[params.slug];
    if (target) legacyRedirect(target);
    if (!isGuideSlug(params.slug)) throw notFound();
  },
  component: GuidePage,
  notFoundComponent: () => <NotFound hubPath="/blog" hubLabel="Blog & Resources" />,
  head: ({ params }) => guideHead(params.slug),
});
